import { Button, Divider, Grid, IconButton, Typography } from "@mui/material";
import { CardProps } from "..";
import { PaperBox } from "../../../../../../components/Layout/PaperBox";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import { TPagamentoDetalhes, TParametrosPagamento } from "../../../../../../types/api/comercial/detalhar-pedido";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useContext, useMemo, useState } from "react";
import DialogDetalheParcelas from "../DialogDetalheParcelas";
import { DadoValorPrinter } from "../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { Edit } from "@mui/icons-material";
import EditarPagamento from "../EditarPagamento";
import { AuthContext } from "../../../../../../contexts/AuthContext";
import { IPerfisVinculados } from "../../../../../../types/api/geral/usuario";
import DialogEmitirBoleto from "./DialogEmitirBoleto";
import { useQueryClient } from "react-query";

export default function CardValores({
    data
}: PropsCardValores) {

    const queryClient = useQueryClient()

    const [openParcelas, setOpenParcelas] = useState<TParametrosPagamentoComValor | null>(null);
    const [openEmitirBoleto, setOpenEmitirBoleto] = useState<TOpenBoleto>({ open: false, valorBoleto: 0, titulo: null, parametros: null });
    const [openDialogEdit, setOpenDialogEdit] = useState<boolean>(false);
    const { getUserData } = useContext(AuthContext);
    const verificarParcelas = (parametros: TParametrosPagamento) => {
        const quantidade = parametros.parcelas.length
        const valor_total = parametros.parcelas.reduce((acc, item) => acc + item.valor, 0)
        return { quantidade, valor_total }
    }

    const vendedores = useMemo(() => {
        const perfisVendedores = getUserData()?.perfis_vinculados
            .filter((perfil: IPerfisVinculados) =>
                perfil.vendedor &&
                perfil.vendedor.id === data.vendedor.id
            ) || []
        return perfisVendedores.map((perfil: any) => perfil.vendedor).length > 0;
    }, [getUserData, data])

    const handleCloseEditarPagamento = () => {
        queryClient.invalidateQueries('comercial/detalhar-pedido');
        setOpenDialogEdit(false);
    }

    return (
        <PaperBox>
            <Grid sx={{ direction: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Valores</Typography>

                {(data.situacao === "Pagamento" || data.situacao === "Aprovação") && vendedores && (
                    <IconButton size="small"
                        onClick={() => setOpenDialogEdit(true)}
                    >
                        <Edit />
                    </IconButton>
                )}
            </Grid>

            <DadoValorPrinter
                titulo="Condição de pagamento"
                valor={data.condicao_pagamento.nome}
            />

            <Divider />
            {
                data.pagamentos.map((item, index) => {
                    let parametros: TParametrosPagamentoComValor | null = null
                    if (item.parametros) {
                        parametros = {
                            ...item.parametros,
                            valor: item.valor,
                        }
                    }

                    const titulo = item.parametros && item.parametros.forma_recebida && item.parametros.forma_recebida.codigo_gerado;
                   

                    return (
                        <Grid container spacing={2} key={index}>
                            <Grid size={{xs: 10}}>
                                <Typography
                                    variant="subtitle2">{(item.parametros && item.parametros.parcelas.length > 1) ? `${formatarValorMonetario(verificarParcelas(item.parametros).valor_total)} em ${verificarParcelas(item.parametros).quantidade}x` : formatarValorMonetario(verificarParcelas(item.parametros).valor_total)}</Typography>
                                <Typography variant="caption" color="text.secondary" display={'block'}>
                                    {item.forma_recebimento.nome}
                                </Typography>
                                {
                                    item.parametros && item.parametros.forma_recebida &&
                                    <Typography variant="caption" color="text.secondary" display={'block'}>
                                        {item.parametros.forma_recebida.tipo} - {item.parametros.forma_recebida.codigo_gerado}
                                    </Typography>
                                }
                                {
                                    item.forma_recebimento.id === 7 && item.status === "Pago" && (data.situacao !== "Pagamento" && data.situacao !== "Cancelado") &&
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => setOpenEmitirBoleto({ open: true, valorBoleto: item.valor, titulo: titulo || null, parametros: parametros })}
                                    >
                                        Emitir boleto
                                    </Button>
                                }
                            </Grid>

                            <Grid size={{xs: 2}} alignSelf="center">
                                <IconButton
                                    size="small"
                                    disabled={!Boolean(item.parametros && item.parametros.parcelas.length > 0 && item.valor !== item.parametros.parcelas.reduce((acc, parcela) => acc + parcela.valor, 0))}
                                    onClick={() => setOpenParcelas(parametros)}
                                >
                                    <VisibilityIcon fontSize="inherit" />
                                </IconButton>
                            </Grid>
                        </Grid>

                    )
                })
            }

            <Grid container sx={{ mt: 1, borderTop: '1px solid #e0e0e0', pt: 1 }}>
                <Grid size={{xs: 12}}>
                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Subtotal:</span>
                        <span>{formatarValorMonetario(data.subtotal)}</span>
                    </Typography>

                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Acréscimos:</span>
                        <span>{formatarValorMonetario(data.acrescimos)}</span>
                    </Typography>

                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Frete:</span>
                        <span>{formatarValorMonetario(data.frete)}</span>
                    </Typography>

                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Descontos:</span>
                        <span>-{formatarValorMonetario(data.descontos)}</span>
                    </Typography>

                    <Typography variant="subtitle1" sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontWeight: 'bold',
                        mt: 1
                    }}>
                        <span>Total:</span>
                        <span>{formatarValorMonetario(data.total + data.frete)}</span>
                    </Typography>
                </Grid>
            </Grid>
            {
                openEmitirBoleto.open && openEmitirBoleto.titulo && openEmitirBoleto.parametros &&
                <DialogEmitirBoleto
                    open={openEmitirBoleto.open}
                    titulo={openEmitirBoleto.titulo}
                    loja_id={data.loja_faturamento.id}
                    parametros={openEmitirBoleto.parametros}
                    onClose={() => setOpenEmitirBoleto({ open: false, valorBoleto: 0, titulo: null, parametros: null })}
                />
            }
            {
                openDialogEdit &&
                <EditarPagamento
                    open={openDialogEdit}
                    onClose={handleCloseEditarPagamento}
                />
            }

            {
                Boolean(openParcelas) && openParcelas &&
                <DialogDetalheParcelas
                    open={Boolean(openParcelas)}
                    parametros={openParcelas}
                    onClose={() => setOpenParcelas(null)}
                />
            }

        </PaperBox>
    )
}

interface PropsCardValores extends CardProps {
}

export type TParametrosPagamentoComValor = TParametrosPagamento & {
    valor: number;
};

type TOpenBoleto = {
    open: boolean;
    valorBoleto: number;
    titulo: string | number | null;
    parametros: TParametrosPagamentoComValor | null;
}